import React, { ReactNode } from 'react'
import { Checkbox as CheckboxElement } from '@elamajs/ui-kit'

import * as Styled from './Checkbox.styled'

type Props = {
  onChange: (checked: boolean) => void
  checked: boolean
  label: string | ReactNode
  name: string
}

const Checkbox = ({ onChange, checked, name, label }: Props) => {
  return (
    <Styled.CheckboxElement
      as={CheckboxElement}
      label={label}
      name={name}
      checked={checked}
      onChange={onChange}
    />
  )
}

export default Checkbox
